import cn from 'classnames';
import React from 'react';
import CountUp from 'react-countup';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Track } from 'services/action';

import { Form, Page } from 'ui/components';
import { formatDate } from 'utilities/common';

import LogoWhiteT from 'ui/assets/envio-white-t.png';
import icon1 from 'ui/assets/icon1.png';
import icon2 from 'ui/assets/icon2.png';
import icon3 from 'ui/assets/icon3.png';
import icon4 from 'ui/assets/icon4.png';

const TrackingScreen = () => {
  const Dispatch = useDispatch();
  const History = useHistory();

  const StateLoading = useSelector((state) => state?.Activity?.processing);

  const [code, setCode] = React.useState('');
  const [error, setError] = React.useState(false);
  const [noResult, setNoResult] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const onStart = () => {
    setLoading(true);
  };

  const onEnd = () => {
    setLoading(false);
  };

  const containerProps = {
    'aria-busy': loading,
  };

  const $getTracking = async (e) => {
    setError(false);
    setNoResult(false);

    if (!code) {
      setError(true);

      setTimeout(function () {
        setError(false);
      }, 8000);

      return;
    }

    await Dispatch(Track.$get({ code: code })).then((res) => {
      if (res?.message === 'success' && res?.data) {
        History.push(`/track/?code=${code}`);
      } else {
        setNoResult(true);
        setTimeout(function () {
          setNoResult(false);
        }, 8000);
      }
    });
  };

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Page type="form" onSubmit={$getTracking}>
      <Page.Body>
        <div>
          <div className="price text-center">
            <div className="container">
              <div className="row m-0 justify-content-center p-3 p-md-5">
                <div className="col-12 col-md-12 p-3 p-md-5">
                  <div className="fs-2 text-white fw-bold">
                    Unified Tracking System
                  </div>
                  <div className="row justify-content-center pt-3">
                    <div className="col-12 col-md-12 col-lg-12 position-relative">
                      <Form.Textbox
                        className="py-2"
                        type="text"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="Masukan kode (kode order, kode shipment, atau kode tracking)"
                        error={error || noResult}
                        rows={8}
                      />

                      <div
                        className="invalid-feedback mt-n2 position-absolute"
                        style={{ display: 'block' }}
                      >
                        {error ? 'Kode harus diisi' : null}

                        {noResult ? 'Kode tidak ditemukan' : null}
                      </div>

                      <button
                        type="submit"
                        className={cn(
                          'btn btn-primary fs-5 rounded px-5 mt-3',
                          StateLoading ? 'btn-loading' : null
                        )}
                        disabled={StateLoading}
                      >
                        Track
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="position-relative mb-3 mb-md-5 ">
              <div className="mt-md-n4 mt-3">
                <div className="bg-white row m-0 align-items-center justify-content-center rounded rounded-4 shadow-sm ">
                  <div className="col-md-5 p-0">
                    <div className="bg-logo">
                      <div className="px-md-3 py-md-4 p-3">
                        <div className="fw-bold fs-5 mb-3">
                          About Envio Network
                        </div>
                        <div>
                          Envio is a Digital Logistics Platform focused on
                          optimizing the Supply Chain Process by providing a
                          unified access to Fulfilment, Handling &amp;
                          Multimodal Transportation Solution through our Network
                          of Service Providers.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 ">
                    <div className="px-md-3 py-md-3 p-3">
                      <div className="row m-0 p-0 justify-content-center border-start border-primary border-sm-none">
                        <div className="col-md-3 col-6 text-center mb-3 mb-md-0 p-0">
                          <img src={icon1} alt="" className="icons" />
                          <div
                            className="fw-semibold d-flex align-items-center justify-content-center"
                            style={{ minHeight: 40 }}
                          >
                            Operators In Network
                          </div>
                          <CountUp
                            start={0}
                            end={97}
                            duration="5"
                            onStart={onStart}
                            onEnd={onEnd}
                            decimals={0}
                            containerProps={containerProps}
                            className="fw-bold fs-4"
                          />
                        </div>
                        <div className="col-md-3 col-6 text-center mb-3 mb-md-0 p-0">
                          <img src={icon2} alt="" className="icons" />
                          <div
                            className="fw-semibold d-flex align-items-center justify-content-center"
                            style={{ minHeight: 40 }}
                          >
                            Trucks In Network
                          </div>
                          <CountUp
                            start={0}
                            end={7528}
                            duration="5"
                            onStart={onStart}
                            onEnd={onEnd}
                            decimals={0}
                            containerProps={containerProps}
                            className="fw-bold fs-4"
                          />
                        </div>
                        <div className="col-md-3 col-6 text-center mb-3 mb-md-0 p-0">
                          <img src={icon3} alt="" className="icons" />
                          <div
                            className="fw-semibold d-flex align-items-center justify-content-center"
                            style={{ minHeight: 40 }}
                          >
                            Last Mile Couriers
                          </div>
                          <CountUp
                            start={0}
                            end={753}
                            duration="5"
                            onStart={onStart}
                            onEnd={onEnd}
                            decimals={0}
                            containerProps={containerProps}
                            className="fw-bold fs-4"
                          />
                        </div>
                        <div className="col-md-3 col-6 text-center p-0">
                          <img src={icon4} alt="" className="icons" />
                          <div
                            className="fw-semibold d-flex align-items-center justify-content-center"
                            style={{ minHeight: 40 }}
                          >
                            Warehouse &amp; Fulfilment Centres
                          </div>
                          <CountUp
                            start={0}
                            end={45}
                            duration="5"
                            onStart={onStart}
                            onEnd={onEnd}
                            decimals={0}
                            containerProps={containerProps}
                            className="fw-bold fs-4"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Page.Body>

      <Page.Footer>
        <footer className="footer bg-primary d-print-none">
          <div className="container py-3 py-md-4">
            <div className="row text-start text-light">
              <div className="col-lg-4">
                <div>
                  <img src={LogoWhiteT} alt="" className="navbar-brand-image" />
                </div>
                <div className="pt-3 mt-n1 pt-md-5">
                  <p className="mb-3 fs-7">
                    Copyright @ {formatDate(new Date(), 'YYYY')} envio.co.id{' '}
                    <br /> All rights reserved.
                  </p>
                </div>
              </div>
              <div className="col-lg-4">
                <div>
                  <p className="mb-0 fw-bolder fs-6">Email</p>
                  <p className="fs-7 mb-0 mb-md-2 pb-md-1">
                    support@envio.co.id
                  </p>
                </div>
                <div className="pt-3 pt-md-4">
                  <p className="mb-0 fw-bolder fs-6">Work Hour</p>
                  <p className="fs-7">Monday - Friday, 09.00 - 21.00 GMT +7</p>
                </div>
              </div>
              <div className="col-lg-4">
                <p className="mb-0 fw-bolder fs-6">Address</p>
                <p className="fs-7">
                  Jl. Puri Kembangan No.57F, RT.11/RW.5,
                  <br /> Kembangan Selatan, Kec. Kembangan, Kota Jakarta Barat.
                  <br /> Daerah Khusus Ibukota Jakarta 11610
                </p>
              </div>
            </div>
          </div>
        </footer>
      </Page.Footer>
    </Page>
  );
};

export default TrackingScreen;
